"use strict";
require('slick-carousel');

const Sliders = () => {
    const init = () => {
        $(document).ready(function() {
            var $homeSliderContainer = $('.js-home-slider-container');
            if ($homeSliderContainer.length > 0) {
                var $homeMobileSlider = $homeSliderContainer.find('.js-home-mobile-slider');
                var $homeSlider = $homeSliderContainer.find('.js-home-slider');
                var $dots = $homeSliderContainer.find('.js-home-slider-dot');
                var $images = $homeSliderContainer.find('.js-home-slider-img');
                var $text = $homeSliderContainer.find('.js-home-slider-text');

                $homeMobileSlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: true,
                    touchThreshold: 500,
                });

                /*$homeSlider.swipeDetector().on("swipeLeft.sd swipeRight.sd", function(event) {
                    if (event.type === "swipeLeft") {
                        nextHomeSlide();
                    } else if (event.type === "swipeRight") {
                        prevHomeSlide();
                    }
                });*/

                $homeSlider.find('.container').on('click', function(e){
                    if(!$(e.target).hasClass('btn') && !$(e.target).parents('.btn').length){
                        if(e.pageX <= $(window).width()*1/3){
                            prevHomeSlide();
                        }else if(e.pageX >= $(window).width()*2/3){
                            nextHomeSlide();
                        }
                    }
                });

                function prevHomeSlide(){
                    if($dots.filter('.active').prev().length){
                        $dots.filter('.active').prev().trigger('click');
                    }else{
                        $dots.filter(':last-child').trigger('click');
                    }
                }

                function nextHomeSlide(){
                    if($dots.filter('.active').next().length){
                        $dots.filter('.active').next().trigger('click');
                    }else{
                        $dots.filter(':first-child').trigger('click');
                    }
                }

                function showHomeSlide(index) {
                    $dots.removeClass('active');
                    $dots.filter('[data-index="'+index+'"]').addClass('active');
                    $images.filter('.active').addClass('inactive');
                    $images.filter('[data-index="'+index+'"]').addClass('active');
                    $text.filter('.active').addClass('inactive');
                    $text.filter('[data-index="'+index+'"]').addClass('active');
                    window.setTimeout(function(){
                        $images.filter('.inactive').removeClass('active inactive');
                        $text.filter('.inactive').removeClass('active inactive');
                    }, 500);
                }

                $dots.on('click', function(){
                    if(!$(this).hasClass('active')){
                        showHomeSlide($(this).data('index'));
                    }
                });
            }

            var $tabbedSliderContainer = $('.js-tabbed-slider-container');
            if ($tabbedSliderContainer.length > 0) {
                var $tabbedSlider = $tabbedSliderContainer.find('.js-tabbed-slider');
                var $tabs = $tabbedSliderContainer.find('.js-tabbed-slider-tab');
                var $tabbedSliderTracker = $tabbedSliderContainer.find('.js-slider-tracker');

                $tabbedSlider.on('init', function(event, slick){
                    $tabbedSliderTracker.css('width', (100/slick.slideCount)+'%');
                });
                
                $tabbedSlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: false,
                    variableWidth: true,
                    mobileFirst: true,
                    touchThreshold: 500,
                    responsive: [
                        {
                          breakpoint: 767,
                          settings: {
                            fade: true,
                            variableWidth: false,
                          }
                        },
                    ],
                });
                
                $tabbedSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $tabs.removeClass('active');
                    $tabs.filter('[data-index="'+currentSlide+'"]').addClass('active');
                    $tabbedSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                });
                
                $tabs.on('click', function(){
                    $tabbedSlider.slick('slickGoTo', $(this).data('index'));
                    $tabs.removeClass('active');
                    $(this).addClass('active');
                });

                $tabbedSliderContainer.find('.js-slider-prev').on('click', function(){
                    $tabbedSlider.slick('slickPrev');
                });
                
                $tabbedSliderContainer.find('.js-slider-next').on('click', function(){
                    $tabbedSlider.slick('slickNext');
                });
            }

            var $gallerySliderContainer = $('.js-gallery-slider-container');
            if ($gallerySliderContainer.length > 0) {
                var $gallerySlider = $gallerySliderContainer.find('.js-gallery-slider');
                var $borders = $gallerySliderContainer.find('.scaling .borders');
                
                $gallerySlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: false,
                    centerMode: true,
                    centerPadding: '20px',
                    touchThreshold: 500,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                centerPadding: '30px',
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                centerPadding: '40px',
                            }
                        },
                        {
                            breakpoint: 1365,
                            settings: {
                                centerPadding: (($gallerySliderContainer.outerWidth() - $borders.outerWidth() + 2)/2)+'px',
                            }
                        },
                    ],
                });

                $gallerySlider.on('setPosition', function(slick){
                    if($(window).width() >= 1366){
                        $gallerySlider.slick('slickSetOption', {
                            centerPadding: (($gallerySliderContainer.outerWidth() - $borders.outerWidth() + 2)/2)+'px',
                        });
                    }
                });
            }

            var $facadesSliderContainer = $('.js-facades-slider-container');
            if ($facadesSliderContainer.length > 0) {
                var $facadesSlider = $facadesSliderContainer.find('.js-facades-slider');
                var $thumbsSlider = $facadesSliderContainer.find('.js-facades-thumbs');
                var $borders = $facadesSliderContainer.find('.scaling .borders');
                
                $facadesSlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: false,
                    centerMode: true,
                    centerPadding: '20px',
                    touchThreshold: 500,
                    asNavFor: '.js-facades-thumbs',
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                centerPadding: '30px',
                            }
                        },
                        {
                            breakpoint: 991,
                            settings: {
                                centerPadding: '40px',
                            }
                        },
                        {
                            breakpoint: 1365,
                            settings: {
                                centerPadding: (($gallerySliderContainer.outerWidth() - $borders.outerWidth() + 2)/2)+'px',
                            }
                        },
                    ],
                });
                
                $facadesSlider.on('setPosition', function(slick){
                    if($(window).width() >= 1366){
                        $facadesSlider.slick('slickSetOption', {
                            centerPadding: (($facadesSliderContainer.outerWidth() - $borders.outerWidth() + 2)/2)+'px',
                        });
                    }
                });
                
                $thumbsSlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: false,
                    variableWidth: true,
                    touchThreshold: 500,
                    asNavFor: '.js-facades-slider',
                });

                window.goToFacadeSlide = function(index){
                    $facadesSlider.slick('slickGoTo', index);
                }
            }

            var $homesSliderContainers = $('.js-homes-slider-container');
            if ($homesSliderContainers.length > 0) {
                $homesSliderContainers.each(function(){
                    var $homesSliderContainer = $(this);
                    var $homesSlider = $homesSliderContainer.find('.js-homes-slider');
                    var $homesSliderTracker = $homesSliderContainer.find('.js-slider-tracker');
                    
                    $homesSlider.on('init', function(event, slick){
                        $homesSliderTracker.css('width', (100/slick.slideCount)+'%');
                    });
                    
                    $homesSlider.slick({
                        infinite: true,
                        arrows: false,
                        dots: false,
                        variableWidth: true,
                        touchThreshold: 500,
                    });
                    
                    $homesSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $homesSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    });
                    
                    $homesSliderContainer.find('.js-slider-prev').on('click', function(){
                        $homesSlider.slick('slickPrev');
                    });
                    
                    $homesSliderContainer.find('.js-slider-next').on('click', function(){
                        $homesSlider.slick('slickNext');
                    });

                    $(window).on('resize', function(){
                        if($homesSliderContainer.find('.home-design').length > 0){
                            var totalSlides = $homesSliderContainer.find('.home-design').length * $homesSliderContainer.find('.home-design').outerWidth();
                            if(totalSlides < $homesSliderContainer.find('.slider-nav').width()){
                                $homesSliderContainer.find('.slider-nav').hide();
                            }else{
                                $homesSliderContainer.find('.slider-nav').css('display', 'flex');
                            }
                        }
                    });
                    $(window).trigger('resize');
                });
            }

            var $virtualSliderContainer = $('.js-virtual-slider-container');
            if ($virtualSliderContainer.length > 0) {
                var $virtualSlider = $virtualSliderContainer.find('.js-virtual-slider');
                var $virtualSliderTracker = $virtualSliderContainer.find('.js-slider-tracker');
                    
                $virtualSlider.on('init', function(event, slick){
                    $virtualSliderTracker.css('width', (100/slick.slideCount)+'%');
                });
                
                $virtualSlider.slick({
                    infinite: true,
                    arrows: false,
                    dots: false,
                    centerMode: true,
                    variableWidth: true,
                    touchThreshold: 500,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 1199,
                            settings: {
                                arrows: true,
                            }
                        }
                    ],
                });

                $virtualSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                    $virtualSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                });
                
                $virtualSliderContainer.find('.js-slider-prev').on('click', function(){
                    $virtualSlider.slick('slickPrev');
                });
                
                $virtualSliderContainer.find('.js-slider-next').on('click', function(){
                    $virtualSlider.slick('slickNext');
                });
            }

            var $colourSliderContainers = $('.js-colour-slider-container');
            if ($colourSliderContainers.length > 0) {
                $colourSliderContainers.each(function(){
                    var $colourSliderContainer = $(this);
                    var $colourSlider = $colourSliderContainer.find('.js-colour-slider');
                    var $colourSliderTracker = $colourSliderContainer.find('.js-slider-tracker');
                    
                    $colourSlider.on('init', function(event, slick){
                        $colourSliderTracker.css('width', (100/slick.slideCount)+'%');
                    });
                    
                    $colourSlider.slick({
                        infinite: true,
                        arrows: false,
                        dots: false,
                        variableWidth: true,
                        touchThreshold: 500,
                    });
                    
                    $colourSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $colourSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    });
                    
                    $colourSliderContainer.find('.js-slider-prev').on('click', function(){
                        $colourSlider.slick('slickPrev');
                    });
                    
                    $colourSliderContainer.find('.js-slider-next').on('click', function(){
                        $colourSlider.slick('slickNext');
                    });
                });
            }

            var $testimonialsSliderContainers = $('.js-testimonials-slider-container');
            if ($testimonialsSliderContainers.length > 0) {
                $testimonialsSliderContainers.each(function(){
                    var $testimonialsSliderContainer = $(this);
                    var $tesimonialsSlider = $testimonialsSliderContainer.find('.js-testimonials-slider');
                    var $tesimonialsSliderTracker = $testimonialsSliderContainer.find('.js-slider-tracker');
                    var $borders = $testimonialsSliderContainer.find('.scaling .borders');
                    
                    $tesimonialsSlider.on('init', function(event, slick){
                        $tesimonialsSliderTracker.css('width', (100/slick.slideCount)+'%');
                    });
                    
                    $tesimonialsSlider.slick({
                        infinite: true,
                        arrows: false,
                        dots: false,
                        touchThreshold: 500,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 767,
                                settings: {
                                    centerMode: true,
                                    centerPadding: '30px',
                                }
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    centerMode: true,
                                    centerPadding: '40px',
                                }
                            },
                            {
                                breakpoint: 1365,
                                settings: {
                                    centerMode: true,
                                    centerPadding: (($testimonialsSliderContainer.outerWidth() - $borders.outerWidth() + 2)/2)+'px',
                                }
                            },
                        ],
                    });
                    
                    $tesimonialsSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
                        $tesimonialsSliderTracker.css('transform', 'translateX('+(100 * nextSlide)+'%)');
                    });
                    
                    $testimonialsSliderContainer.find('.js-slider-prev').on('click', function(){
                        $tesimonialsSlider.slick('slickPrev');
                    });
                    
                    $testimonialsSliderContainer.find('.js-slider-next').on('click', function(){
                        $tesimonialsSlider.slick('slickNext');
                    });

                    $tesimonialsSlider.on('setPosition', function(slick){
                        if($(window).width() >= 1366){
                            $tesimonialsSlider.slick('slickSetOption', {
                                centerPadding: (($testimonialsSliderContainer.outerWidth() - $borders.outerWidth() + 2)/2)+'px',
                            });
                        }
                    });
                });
            }
        });
    };

    return {
        init:init
    };
};

export default Sliders;